const {createSlice} = require('@reduxjs/toolkit');
const {
  fetchSatisfactionList,
  fetchSatisfaction,
} = require('../actions/SatisfactionAction');

const SatisfactionSlice = createSlice({
  name: 'Satisfaction',
  initialState: {
    data: [],
    prevSearchParams: {
      casePriority: null,
      flgStatus: null,
      startTime: null,
      endTime: null,
    },
    selection: null,
    status: 'idle',
    error: '',
    loading: false,
  },

  reducers: {
    saveSearchParams: (state, action) => {
      state.prevSearchParams.casePriority = action.payload.casePriority;
      state.prevSearchParams.flgStatus = action.payload.flgStatus;
      state.prevSearchParams.startTime = action.payload.startTime;
      state.prevSearchParams.endTime = action.payload.endTime;
    },
    clearSearchParams: (state) => {
      state.prevSearchParams.casePriority = null;
      state.prevSearchParams.flgStatus = null;
      state.prevSearchParams.startTime = null;
      state.prevSearchParams.endTime = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSatisfactionList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSatisfactionList.fulfilled, (state, action) => {
        (state.status = 'idle'), (state.data = action.payload);
      })
      .addCase(fetchSatisfactionList.rejected, (state, action) => {
        (state.status = 'rejected'), (state.error = action.error.message);
      })
      .addCase(fetchSatisfaction.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSatisfaction.fulfilled, (state, action) => {
        (state.status = 'idle'), (state.selection = action.payload.result);
      })
      .addCase(fetchSatisfaction.rejected, (state, action) => {
        (state.status = 'rejected'), (state.error = action.error.message);
      });
  },
});
export const getPrevSearchParams = (state) =>
  state.satisfaction.prevSearchParams;
export const {saveSearchParams, clearSearchParams} = SatisfactionSlice.actions;
export default SatisfactionSlice.reducer;
